import { Tab, Spinner, SpinnerSize } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";
import { ERoutes } from "../../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { PersonDetailsPage } from "./PersonDetailsPage";
import { PersonBreederPage } from "./PersonBreederPage";
import { PersonWebUserPage } from "./PersonWebUserPage";
import { PersonLinkedFiles } from "./PersonLinkedFiles";
import { PersonApi } from "../../../../api";
import { PersonMembershipPage } from "./PersonMembershipPage";
import { PersonVetPage } from "./vetInformation/PersonVetPage";
import { PersonHistoryTab } from "./PersonHistoryPage";
import { PersonJudgeSwitch } from "./PersonJudgeSwitch";
import { PersonCommissionerPage } from "./PersonCommissionerPage";

export interface IPersonItemPageProps {}

export const PersonItemPage: React.FunctionComponent<IPersonItemPageProps> = (props) => {
  const { id, tab, state } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();
  const { t } = useTl();
  const api = useApiService(PersonApi);
  const [displayName, loading] = useApiEffect(() => api.getDisplayName(+id), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.People), route: ERoutes.people },
        { text: +id > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
      actionHistory={+id > 0 && { tlCode: ETLCodes.ActionHistoryPerson, name: displayName, id: +id }}
    >
      <ProtectedTabs
        id="TabsPeople"
        onChange={(newTabId) => history.push(`${ERoutes.people}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.people} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<PersonDetailsPage personId={+id} editMode={state === "edit"} />}
        />
        <Tab
          id="webUser"
          title={t(ETLCodes.WebUser)}
          panel={<PersonWebUserPage personId={+id} editMode={state === "edit"} />}
        />
        <Tab
          id="linkedFiles"
          title={t(ETLCodes.LinkedRequests)}
          panel={<PersonLinkedFiles personId={+id} />}
          disabled={+id <= 0}
        />
        <Tab
          id="membership"
          title={t(ETLCodes.Membership)}
          panel={<PersonMembershipPage personId={+id} />}
          disabled={+id <= 0}
        />
        <Tab
          id="breeder"
          title={t(ETLCodes.Breeder)}
          panel={<PersonBreederPage personId={+id} editMode={state === "edit"} />}
          disabled={+id <= 0}
        />
        <Tab id="judge" title={t(ETLCodes.Judge)} disabled={+id <= 0} panel={<PersonJudgeSwitch />} />
        <Tab
          id="veterinary"
          title={t(ETLCodes.Veterinary)}
          panel={<PersonVetPage personId={+id} />}
          disabled={+id <= 0}
        />
        <Tab
          id="commissioner"
          title={t(ETLCodes.Commissioner)}
          panel={<PersonCommissionerPage personId={+id} />}
          disabled={+id <= 0}
        />
        <Tab id="history" title={t(ETLCodes.History)} panel={<PersonHistoryTab personId={+id} />} disabled={+id <= 0} />
      </ProtectedTabs>
    </PageBase>
  );
};
